import { Component, OnInit } from '@angular/core'
import {
    FormBuilder,
    FormGroup,
    FormArray,
    Validators,
    FormControl,
} from '@angular/forms'
//import { SmtpSecurity } from '../../../api/models/smtp-security'
import { LogLevel } from '../../../api/models/log-level'
import { AppSettingService } from '../../../api/services/app-setting.service'
import { SamlSettings } from '../../../api/models/saml-settings'
import { MessageService } from 'primeng/api'
import { DecryptConnectionStringDto, ReportingSetting } from '../../../api/models'
import { fileExtensionValidator } from '../../validators/CareFinityValidators'
import { AuthService } from '../../../api/services/auth.service'
import { validateAllFormFields } from '../../../formUtils'
import { environment } from '../../../../environments/environment'
//import { MfaType } from '../../../api/models/mfa-type'

enum MultipleSessionsOption {
    "Allow Multiple" = 0,
    "End Existing Session" = 1,
    "Not Allowed" = 2
}
enum MfaType {
    None = 0,
    /* Mobile = 1,*/
    /* Email = 2,*/
    AuthApp = 3
}


 enum SmtpSecurity {
     "None" = 0,
     "Auto Detect" = 1,
     "SSL on Connect" = 2,
     "Start TLS" = 3,
     "Start TLS When Available" = 4
}

@Component({
    selector: 'app-application-config',
    templateUrl: './application-config.component.html',
    styleUrls: ['./application-config.component.css'],
})
export class ApplicationConfigComponent implements OnInit {
    frmApplicationSettings: FormGroup;
    connectionForm!: FormGroup;

    multipleSessionsOptions: { key: number; value: string }[]
    smtpSecurityOptions: { key: number; value: string }[]

    mfaTypeOptions: { key: number; value: string }[]

    logLevelOptions: { key: number; value: string }[]

    isEdit = false
    speakText = 'help'
    actionName: string = 'Save'

    isDisabled_ForceComplexPasswords = false

    isDisabled_EmailNotifications = false
    isDisabled_ReportSettings = false

    //testEmailMessage: string = 'test message...';

    testEmailMessage = new FormControl('test message...')

    emailMessage

    password: string = '';
    isPasswordVisible_DSN: boolean[] = [];
    // password: string = '';
    isPasswordVisible_Email: boolean = false;

    isMfaType: boolean = false;

    areportSetting: ReportingSetting;

    isTestdns: boolean = false;

    tempCustomName: string = '';
    isDisabled_CustomName: boolean = true;
    isConnectionStringVisiable: boolean = false;

    showglobalSettingMessage: boolean = false;
    globalMessage: string = "Nice! 🎉 Global settings have loaded successfully from Global XML file.";


    isConnectionStringDecryptVisiable: boolean = false;
    mycareFinityConnectionString: string = '';
    myeHREMRConnectionString: string = '';

    isDecConVisiable: boolean = false;

    decitems: DecryptConnectionStringDto;
    isCopiedCareFinity = false;
    isCopiedEhremrConstring = false;


    isDisabled: boolean = true;

    isSaving: boolean = false;
    constructor(
        private fb: FormBuilder,
        private appSettingService: AppSettingService,
        private messageService: MessageService,
        private authService: AuthService,
    ) {
        this.testEmailMessage.valueChanges.subscribe((value) => {
            this.emailMessage = value
        })
    }

    ngOnInit(): void {
        // Initialize dropdown options
        this.multipleSessionsOptions = this.getEnumOptions(MultipleSessionsOption)

        this.smtpSecurityOptions = this.getEnumOptions(SmtpSecurity)

        this.mfaTypeOptions = this.getEnumOptions(MfaType)

        this.logLevelOptions = this.getEnumOptions(LogLevel)

        // Initialize the form group using FormBuilder
        this.frmApplicationSettings = this.fb.group({
            // UserAccountPolicy
            accountPolicy: this.fb.group({
                cantUseSamePasswordFor: [10],
                forceComplexPasswords: [true],
                maxFailedLoginAttempts: [10],
                maxFailedOtpCount: [5],
                mfaType: [MfaType],
                minLowerCaseChars: [0],
                minNumbers: [0],
                minPasswordLength: [12],
                minSpecialChars: [0],
                minUpperCaseChars: [0],
                multipleSessions: [MultipleSessionsOption],
                passwordExpiryDays: [0],
                sessionExpiryWarningBeforeSeconds: [60],
                sessionTimeoutMinutes: [10],
                oTpGeneratorLink: [null],
                countryCode: [null],
            }),
            apiDataPageSize: [10],
            // ApplicationFeatures
            applicationFeatures: this.fb.group({
                showExportCCDA: [false],
                showPatientDocuments: [true],
                showReports: [true],
            }),
            chromiumBaseDirectory: [null],
            copyRight: [null],
            emailNotifications: [false],
            emailNotificationsTo: [null],
            enterpriseId: [null],
            isEmailMandatory: [false],
            isEmergencyTokenEnabled: [false],
            logLevel: [LogLevel.Debug],
            isCellMandatory: [false],
            // ReportingSettings
            reportSettings: this.fb.group({
                reportingSetting: this.fb.array([]),
            }),
            // SmtpSettings
            smtpSettings: this.fb.group({
                fromAddress: [null],
                fromDisplayName: [null],
                host: [null],
                password: [null],
                port: [0],
                security: [SmtpSecurity],
                userName: [null],
            }),
            // SsoSettings
            ssoSettings: this.fb.group({
                saml: this.fb.array([]), // FormArray for SAML settings
            }),
            version: [null],
            isCustomLogo: [false],
            customLogoName: [null, fileExtensionValidator(['.png', '.jpg'])],
            isImportSettings: [false]
        })
        this.connectionForm = this.fb.group({
            careFinityConstring: [null],
            ehremrConstring: [null]
        });
        // Fetch and set initial data
        this.appSettingService
            .appSettingGetApplicationsetting({ type: '1', practiceId: null })
            .subscribe((res) => {
                if (res) {
                    this.isEdit = true
                    this.actionName = 'Update'
                    this.frmApplicationSettings.patchValue(res)
                    this.setSamlSettings(res.ssoSettings?.saml || []) // Update FormArray
                    this.setreportsettingSettings(res.reportSettings?.reportingSetting || []) // Update FormArray
                } else {
                    this.isEdit = false
                    this.frmApplicationSettings.patchValue(res)
                }
            })

        // Subscribe to value changes for specific controls to ensure numeric values
        this.addValueChangeSubscriptions()
    }

    // Helper function to convert enum to dropdown options
    private getEnumOptions(enumType: any): { key: number; value: string }[] {
        return Object.keys(enumType)
            .filter((key) => !isNaN(Number(enumType[key])))
            .map((key) => ({ key: enumType[key], value: key }))
    }

    // Adding subscriptions to specific controls
    private addValueChangeSubscriptions(): void {
        this.frmApplicationSettings
            .get('accountPolicy.multipleSessions')
            ?.valueChanges.subscribe((value) => {
                this.convertToNumberIfString('accountPolicy.multipleSessions', value)
            })

        this.frmApplicationSettings
            .get('smtpSettings.security')
            ?.valueChanges.subscribe((value) => {
                this.convertToNumberIfString('smtpSettings.security', value)
            })

        this.frmApplicationSettings
            .get('logLevel')
            ?.valueChanges.subscribe((value) => {
                this.convertToNumberIfString('logLevel', value)
            })

        this.frmApplicationSettings
            .get('accountPolicy.forceComplexPasswords')
            ?.valueChanges.subscribe((res) => {
                this.isDisabled_ForceComplexPasswords = res
                if (res) {
                    this.frmApplicationSettings
                        .get('accountPolicy.minPasswordLength')
                        .enable()
                    this.frmApplicationSettings
                        .get('accountPolicy.minUpperCaseChars')
                        .enable()
                    this.frmApplicationSettings
                        .get('accountPolicy.minLowerCaseChars')
                        .enable()
                    this.frmApplicationSettings
                        .get('accountPolicy.minSpecialChars')
                        .enable()
                    this.frmApplicationSettings.get('accountPolicy.minNumbers').enable()
                    this.frmApplicationSettings
                        .get('accountPolicy.cantUseSamePasswordFor')
                        .enable()
                } else {
                    // checkboxControl?.disable(); // Disable the checkbox
                    this.frmApplicationSettings
                        .get('accountPolicy.minPasswordLength')
                        .disable()
                    this.frmApplicationSettings
                        .get('accountPolicy.minUpperCaseChars')
                        .disable()
                    this.frmApplicationSettings
                        .get('accountPolicy.minLowerCaseChars')
                        .disable()
                    this.frmApplicationSettings
                        .get('accountPolicy.minSpecialChars')
                        .disable()
                    this.frmApplicationSettings.get('accountPolicy.minNumbers').disable()
                    this.frmApplicationSettings
                        .get('accountPolicy.cantUseSamePasswordFor')
                        .disable()
                }
            })

        this.frmApplicationSettings
            .get('emailNotifications')
            ?.valueChanges.subscribe((res) => {
                this.isDisabled_EmailNotifications = res
                if (res) {
                    this.frmApplicationSettings.get('smtpSettings.fromAddress').enable()
                    this.frmApplicationSettings
                        .get('smtpSettings.fromDisplayName')
                        .enable()
                    this.frmApplicationSettings.get('smtpSettings.host').enable()
                    this.frmApplicationSettings.get('smtpSettings.password').enable()
                    this.frmApplicationSettings.get('smtpSettings.port').enable()
                    this.frmApplicationSettings.get('smtpSettings.userName').enable()

                    this.frmApplicationSettings.get('smtpSettings.security').enable()

                    this.frmApplicationSettings.get('emailNotificationsTo').enable()
                } else {
                    // checkboxControl?.disable(); // Disable the checkbox

                    this.frmApplicationSettings.get('smtpSettings.fromAddress').disable()
                    this.frmApplicationSettings
                        .get('smtpSettings.fromDisplayName')
                        .disable()
                    this.frmApplicationSettings.get('smtpSettings.host').disable()
                    this.frmApplicationSettings.get('smtpSettings.password').disable()
                    this.frmApplicationSettings.get('smtpSettings.port').disable()
                    this.frmApplicationSettings.get('smtpSettings.userName').disable()

                    this.frmApplicationSettings.get('smtpSettings.security').disable()

                    this.frmApplicationSettings.get('emailNotificationsTo').disable()
                }
            })

        this.frmApplicationSettings.get('accountPolicy.mfaType')?.valueChanges.subscribe((res) => {

            if (res == 1) {
                this.isMfaType = true;
            }
            else {
                this.isMfaType = false;
            }


        })

        this.isDisabled_ReportSettings = this.frmApplicationSettings.get('applicationFeatures.showReports').value



        this.frmApplicationSettings
            .get('applicationFeatures.showReports')
            ?.valueChanges.subscribe((res) => {
                this.isDisabled_ReportSettings = res
                if (res) {


                    this.isDisabled_ReportSettings = true;



                } else {

                    this.isDisabled_ReportSettings = false;



                }
            })



        this.frmApplicationSettings
            .get('isCustomLogo')
            ?.valueChanges.subscribe((res) => {

                this.tempCustomName = this.frmApplicationSettings.get('customLogoName').value;
                if (res) {
                    this.isDisabled_CustomName = false;
                    this.frmApplicationSettings.get('customLogoName')?.setValue(this.tempCustomName);
                } else {

                    this.frmApplicationSettings.get('customLogoName')?.setValue(null);
                    this.isDisabled_CustomName = true;



                }
            })







    }




    // Convert control value to number if it's a string
    private convertToNumberIfString(controlPath: string, value: any): void {
        if (typeof value === 'string' && !isNaN(Number(value))) {
            this.frmApplicationSettings
                .get(controlPath)
                ?.setValue(Number(value), { emitEvent: false })
        }
    }

    // SAML FormArray management
    get samlFormArray(): FormArray {
        return this.frmApplicationSettings.get('ssoSettings.saml') as FormArray
    }

    addSamlSettings(): void {
        this.samlFormArray.push(this.createSamlSettingsFormGroup())
    }

    private setSamlSettings(samlSettings: SamlSettings[]): void {
        const samlFormArray = this.frmApplicationSettings.get('ssoSettings.saml') as FormArray
        samlFormArray.clear() // Clear existing controls
        // this.frmApplicationSettings.reset();
        samlSettings.forEach((setting) => {
            samlFormArray.push(this.createSamlSettingsFormGroup(setting))
        })
    }

    removeSamlSettings(index: number): void {
        this.samlFormArray.removeAt(index)
    }

    private createSamlSettingsFormGroup(samlSettings?: SamlSettings): FormGroup {
        return this.fb.group({
            certificatePath: [samlSettings?.certificatePath || null],
            collapsedMenuBar: [samlSettings?.collapsedMenuBar || false],
            dobAttribute: [samlSettings?.dobAttribute || null],
            ehrPracticeIdAttribute: [samlSettings?.ehrPracticeIdAttribute || null],
            firstNameAttribute: [samlSettings?.firstNameAttribute || null],
            lastNameAttribute: [samlSettings?.lastNameAttribute || null],
            mrnAttribute: [samlSettings?.mrnAttribute || null],
            senderEntityID: [samlSettings?.senderEntityID || null],
            tracePath: [samlSettings?.tracePath || null],
            traceRequests: [samlSettings?.traceRequests || false],
        })
    }



    // Reports FormArray management
    get reportsettingFormArray(): FormArray {
        return this.frmApplicationSettings.get('reportSettings.reportingSetting') as FormArray
    }

    addreportsettingSettings(): void {
        this.reportsettingFormArray.push(this.createReportSettingsFormGroup())
    }

    private setreportsettingSettings(reportSettings: ReportingSetting[]): void {
        const reportsettingFormArray = this.frmApplicationSettings.get('reportSettings.reportingSetting') as FormArray
        reportsettingFormArray.clear() // Clear existing controls
        // this.frmApplicationSettings.reset();
        reportSettings.forEach((setting) => {
            reportsettingFormArray.push(this.createReportSettingsFormGroup(setting))
        })
    }

    removereportsettingSettings(index: number): void {
        // alert(index);
        this.reportsettingFormArray.removeAt(index)
    }

    private createReportSettingsFormGroup(reportSettings?: ReportingSetting): FormGroup {
        return this.fb.group({
            path: [reportSettings?.path || null],
            dsn: [reportSettings?.dsn || null],
            database: [reportSettings?.database || null],
            userName: [reportSettings?.userName || null],
            password: [reportSettings?.password || null],
        })
    }









    // Form submission
    //onSubmit(): void
    //{

    //    if (this.isSaving) return;
    //    // Prevent multiple submissions
    //    this.isSaving = true;
    //    if (this.frmApplicationSettings.valid)
    //    {
    //        const formData = this.frmApplicationSettings.value

    //        if (!this.isEdit) {
    //            this.actionName = 'Save'
    //            this.appSettingService
    //                .appSettingSaveApplicationSettings({
    //                    type: '0',
    //                    practiceId: null,
    //                    body: formData,
    //                })
    //                .subscribe(
    //                    (result) => {
    //                        console.log(result)

    //                        this.messageService.add({
    //                            key: 'alertToast',
    //                            severity: 'success',
    //                            detail: 'Application settings  are added successfully',
    //                            summary: 'Confirmation',
    //                            life: 5000,
    //                        })
    //                        //this.frmApplicationSettings.reset();
    //                    },
    //                    (err) => {
    //                        this.messageService.add({
    //                            key: 'alertToast',
    //                            severity: 'error',
    //                            detail: err.error,
    //                            summary: 'ERROR',
    //                            life: 7000,
    //                        })
    //                    },
    //                )
    //        } else {
    //            this.actionName = 'Update'
    //            this.appSettingService
    //                .appSettingUpdateApplicationSettings({
    //                    type: '0',
    //                    practiceId: null,
    //                    body: formData,
    //                })
    //                .subscribe(
    //                    (result) => {
    //                        console.log(result)

    //                        this.messageService.add({
    //                            key: 'alertToast',
    //                            severity: 'success',
    //                            detail: 'Application settings  are updated successfully',
    //                            summary: 'Confirmation',
    //                            life: 5000,
    //                        })
    //                        // this.frmApplicationSettings.reset();
    //                    },
    //                    (err) => {
    //                        this.messageService.add({
    //                            key: 'alertToast',
    //                            severity: 'error',
    //                            detail: err.error,
    //                            summary: 'ERROR',
    //                            life: 7000,
    //                        })
    //                    },
    //                )
    //        }
    //    }

    //    // Delay 2 seconds before enabling
    //    setTimeout(() => {
    //        this.isSaving = false;
    //    }, 2000);

    //}


    onSubmit(): void {

        if (this.isSaving || !this.frmApplicationSettings.valid) return;
        this.isSaving = true;
        const formData = this.frmApplicationSettings.value;
        const action = this.isEdit
            ? this.appSettingService.appSettingUpdateApplicationSettings({ type: '0', practiceId: null, body: formData })
            : this.appSettingService.appSettingSaveApplicationSettings({ type: '0', practiceId: null,  body: formData});
            this.actionName = this.isEdit ? 'Update' : 'Save';

        action.subscribe({
            next: (result) => {
                console.log(result);
                this.messageService.add({ key: 'alertToast', severity: 'success',summary: 'Confirmation',detail: `Application settings are ${this.isEdit ? 'updated' : 'added'} successfully`,life: 5000});
                // Optionally reset form: this.frmApplicationSettings.reset();

            },
            error: (err) => {this.messageService.add({key: 'alertToast',severity: 'error',summary: 'ERROR',detail: err.error,life: 7000});
            },
            complete: () => {

                   setTimeout(() => {
                       this.isSaving = false;
                   }, environment.setDelayTimeOut);


            },
        });

    }


    private speak(text: string) {
        // alert(text);
        const utterance = new SpeechSynthesisUtterance(text)

        window.speechSynthesis.speak(utterance)
    }
    //#region ToolTip  messages

    getContolTip(controlType: string) {
        this.speakText = ''

        switch (controlType.toUpperCase()) {

            //# ::General Settings::

            case 'ENTERPRISEID': {
                this.speakText = 'Displays unique Enterprise identifier assigned to practices within CareFinity®'
                break;
            }
            case 'PAGESIZE': {
                this.speakText = 'Maximum number of items displayed per page in CareFinity®'
                break;
            }
            case 'LOGDETAILS': {
                this.speakText = 'Users can select the desired log level to control the verbosity of log messages. Higher levels provide more detailed information for debugging purposes in CareFinity®'
                break;
            }
            case 'CHROMIUM': {
                this.speakText = 'Directory used by CareFinity®’s Chromium-based features.'
                break;
            }
            case 'EMERGENCYTOKENENABLED': {
                this.speakText = 'Activates a token for emergency access to CareFinity®'
                break
            }
            case 'EMAILMANDATORY': {
                this.speakText = 'Enforce users to provide an email address during registration for CareFinity® notification.'
                break;
            }
            case 'CELLPHONEMANDATORY': {
                this.speakText = 'Enforce users to provide a phone number during the user creation for CareFinity® notification.'
                break;
            }

            case 'SHOWMEDTECHLOGO': {
                this.speakText = 'Enbale to show  med tech solution logo on top left on logic page.'
                break;
            }

            //# ::  Account Policy::

            case 'SESSIONTIMEOUT': {
                this.speakText = `Set time in minutes before user's session automatically logs out due to inactivity`;
                break;
            }
            case 'SESSIONTIMEOUTSEC': {
                this.speakText = 'Set time in seconds before automatic logout when a warning alert appears';
                break;
            }
            case 'PASSWORDEXPIRY': {
                this.speakText = 'Set the number of days before user password must be changed';
                break;
            }
            case 'FAILEDLOGINATTEMPTS': {
                this.speakText = 'Set the number of incorrect login tries allowed before user account is locked.';
                break;
            }
            case 'MULTIPLESESSIONS': {
                this.speakText = 'Choose whether to allow/ not allow multiple logins or end existing sessions when a new login occurs.';
                break;
            }
            case 'FORCECOMPLEXPASSWORDS': {
                this.speakText = 'This setting force the complex password criteria (based on below settings) upon user creation.';
                break;
            }
            case 'MINIMUMPASSWORD': {
                this.speakText = 'Set the smallest number of characters required for a password.';
                break;
            }
            case 'MINIMUMUPPER': {
                this.speakText = 'Set the number of uppercase characters that must be included in the password.';
                break;
            }
            case 'MINIMUMLOWER': {
                this.speakText = 'Set the number of lowercase characters that must be included in the password.';
                break;
            }
            case 'SPECIALCHARS': {
                this.speakText = 'Set the number of special characters that must be included in the password.';
                break;
            }
            case 'MINNUMBER': {
                this.speakText = 'Set the number of numeric characters that must be included in the password.';
                break;
            }
            case 'HISTORYCOUNT': {
                this.speakText = 'Specifies how many past passwords are stored to restrict reuse.';
                break;
            }

            //#Multi Factor Authentication::

            case 'MFATYPE': {
                this.speakText = 'Select preferred Multi-Factor Authentication (MFA) method to enhance account security.';
                break;
            }
            case 'COUNTRYCODE': {
                this.speakText = 'Select your country code for your phone number.';
                break;
            }
            case 'FAILEDOTP': {
                this.speakText = 'Set the maximum number of incorrect OTP attempts allowed before the user is temporarily locked out.';
                break;
            }
            case 'OTPGENERATOR': {
                this.speakText = 'Click to generate a one-time password (OTP) for secure authentication. The link will expire after a short period.';
                break;
            }

            //# Report Settings::

            case 'SHOWREPORTS': {
                this.speakText = 'Controls access to report management module and related permissions under manage roles. When selected, enables the below related settings that needs to be configured.';
                break;
            }
            case 'REPORTPATH': {
                this.speakText = 'Enter the location or directory where the report file is saved or accessed.';
                break;
            }
            case 'REPORTPATH': {
                this.speakText = 'This is path for reports.'
                break;
            }
            case 'REPORTPATH': {
                this.speakText = 'This is path for reports.'
                break;
            }
            case 'DSNNAME': {
                this.speakText = 'Defines the Data Source Name (DSN) used to connect to the database.';
                break;
            }
            case 'DBNAME': {
                this.speakText = 'Specify the name of the database to connect to for storing or retrieving data within the application.';
                break;
            }
            case 'DSNUSERNAME': {
                this.speakText = 'Indicates the username required to access the data source';
                break;
            }
            case 'DSNPASSWORD': {
                this.speakText = 'Enter the password associated with the DSN username to securely authenticate and connect to the database.';
                break;
            }

            //# Email Notification::

            case 'EMAILNOTIFICATIONS': {
                this.speakText = 'Check to enable email notifications for important updates and alerts.';
                break;
            }
            case 'HOST': {
                this.speakText = 'Enter the SMTP server address used to send email notifications.';
                break;
            }
            case 'PORT': {
                this.speakText = 'Enter the port number used by the SMTP server for sending emails.';
                break;
            }
            case 'USERNAME': {
                this.speakText = 'Enter the email account`s username.';
                break;
            }
            case 'FROMADD': {
                this.speakText = `Specify the email address that will appear as the "sender" of the email notifications`;
                break;
            }
            case 'SMTP': {
                this.speakText = 'Select prefered security protocol (e.g., SSL/TLS) to encrypt the connection to the SMTP server.';
                break;
            }
            case 'PASSWORD': {
                this.speakText = 'Enter the password associated with email account.';
                break;
            }
            case 'EMAILTO': {
                this.speakText = 'Send a test message to verify email settings.'
                break;
            }
            case 'DISPLAYNAME': {
                this.speakText = 'Enter the name that will be displayed as the sender in email notifications.';
                break;
            }
            case 'SENDTO': {
                this.speakText = 'Enter the recipient`s email address.This is the primary address where your email will be sent.';
                break;
            }

            //# SAML Setting

            case 'SAML': {
                this.speakText = 'Configure SAML(Security Assertion Markup Language) settings to enable single sign - on (SSO) and secure authentication with external identity providers in CareFinity®';
                break;
            }
            case 'CERTIFICATEPATH': {
                this.speakText = 'Enter the file location of the security certificate used for authentication.';
                break;
            }
            case 'ENTITYID': {
                this.speakText = 'Enter the unique identifier for the sender (Identity Provider or Service Provider).';
                break;
            }
            case 'ATTRIBUTENAME': {
                this.speakText = `SAML attribute that maps to the user's first name, to populate user profiles during SSO login.`;
                break;
            }
            case 'LASTATTRIBUTENAME': {
                this.speakText = `SAML attribute that maps to the user's first name, to populate user profiles during SSO login.`;
                break;
            }
            case 'DOB': {
                this.speakText = `SAML attribute that maps to the user's date of birth, to populate user profiles during SSO login.`;
                break;
            }
            case 'MRN': {
                this.speakText = `SAML attribute that maps to the user's medical record number, to populate user profiles during SSO login.`;
                break;
            }
            case 'EHR': {
                this.speakText = `SAML attribute that maps to the user's EHR Practice ID, to associate the user with the correct practice during SSO login.`;
                break;
            }
            case 'TRACE': {
                this.speakText = 'Enable detailed logging of SAML authentication requests and responses to help troubleshoot issues.';
                break;
            }
            case 'TRACEPATH': {
                this.speakText = 'Enter the file path or directory where SAML trace logs should be saved.';
                break;
            }
            case 'CMB': {
                this.speakText = `Check to topple the menu bar.`;
                break;
            }


            case 'CUSTOMLOGO': {
                this.speakText = 'Check to upload a custom logo to personalize the appearance of the application.'
                break;
            }

            case 'CUSTOMLOGONAME': {
                this.speakText = 'Enter the name for your custom logo.'
                break;
            }

            case 'ConnectionStrings': {
                this.speakText = 'Holds the encrypted connection strings that configure database or service connections.Global admins can click to view the decrypted connection strings for security purposes'
                break;
            }


          


        }

        // this.speak(this.speakText);

    }

    //#endregion
    testSmtp() {
        const formData = this.frmApplicationSettings.get('smtpSettings').value
        const emailTo = this.frmApplicationSettings.get(
            'emailNotificationsTo',
        ).value

        // const emailMessage = this.testEmailMessage.get("testEmailMessage").value;

        //alert(this.emailMessage);

        this.appSettingService
            .appSettingTestEmail({
                body: formData,
                emailTo: emailTo,
                emailMessage: this.emailMessage,
            })
            .subscribe(
                (res) => {
                    console.log(res)

                    this.messageService.add({
                        key: 'alertToast',
                        severity: 'success',
                        detail: 'Email Send successfully',
                        summary: 'Confirmation',
                        life: 5000,
                    })
                },
                (err) => {
                    this.messageService.add({
                        key: 'alertToast',
                        severity: 'error',
                        detail: err.error,
                        summary: 'ERROR',
                        life: 7000,
                    })
                },
            )
    }



    //togglePasswordVisibility_DSN(): void {
    //    this.isPasswordVisible_DSN = !this.isPasswordVisible_DSN;
    //}
    togglePasswordVisibility_DSN(index: number): void {
        this.isPasswordVisible_DSN[index] = !this.isPasswordVisible_DSN[index];
    }
    togglePasswordVisibility_Email(): void {
        this.isPasswordVisible_Email = !this.isPasswordVisible_Email;
    }


    testdns(index: number) {
        const setting = this.getReportSetting(index);
        console.log(setting?.value);
        this.areportSetting = setting?.value as ReportingSetting;
        console.log(this.areportSetting);
    }


    getReportSetting(index: number): FormGroup {
        const formArray = this.reportsettingFormArray;

        if (index >= 0 && index < formArray.length) {
            return formArray.at(index) as FormGroup;
        } else {
            console.error("Invalid index:", index);
            return null;
        }
    }


    viewConnectionStrings() {

        this.isConnectionStringVisiable = true;
    }


    // Fetch Global Settings From XmlFile

    fetchGlobalSettingsFromXmlFile() {

        this.appSettingService
            .appSettingGetAppSettingFromGlobalXmlFile({ type: '1', practiceId: null })
            .subscribe({
                next: (res) => {
                    if (res) {
                        this.isEdit = true;
                        this.actionName = 'Update';
                        this.frmApplicationSettings.patchValue(res);
                        this.setSamlSettings(res.ssoSettings?.saml || []);
                        this.setreportsettingSettings(res.reportSettings?.reportingSetting || []);
                        this.showglobalSettingMessage = true;
                        this.isDisabled = false;
                    } else {
                        this.isDisabled = false;
                        this.isEdit = false;
                        this.frmApplicationSettings.patchValue(res);
                        this.showglobalSettingMessage = true;
                    }
                },
                error: (err) => {
                    console.error('Error loading application settings:', err);
                    // Optionally, show a message to the user
                    //  this.toastService?.error('Failed to load application settings. Please try again later.');
                    this.messageService.add({
                        key: 'alertToast',
                        severity: 'error',
                        // detail: 'Failed to load application settings. Please try again later.',
                        detail: err.error,
                        summary: 'ERROR',
                        life: 7000,
                    })
                }
            });

        // Subscribe to value changes for specific controls to ensure numeric values
        this.addValueChangeSubscriptions()
    }


    resetSettings() {
        this.showglobalSettingMessage = false;

        this.appSettingService
            .appSettingGetApplicationsetting({ type: '1', practiceId: null })
            .subscribe((res) => {
                if (res) {
                    this.isEdit = true
                    this.actionName = 'Update'
                    this.frmApplicationSettings.patchValue(res)
                    this.setSamlSettings(res.ssoSettings?.saml || []) // Update FormArray
                    this.setreportsettingSettings(res.reportSettings?.reportingSetting || []) // Update FormArray
                } else {
                    this.isEdit = false
                    this.frmApplicationSettings.patchValue(res)
                }
            })

        // Subscribe to value changes for specific controls to ensure numeric values
        this.addValueChangeSubscriptions()
    }

    resetglobalMessage() {
        this.showglobalSettingMessage = false;
    }

    decryptConnectionStringModel() {
        this.isConnectionStringDecryptVisiable = true;
    }

    decryptConnections() {

        validateAllFormFields(this.connectionForm)
        if (this.connectionForm.invalid) {
            return;
        }
        debugger;
        const frmValues = this.connectionForm.value;
        console.log(frmValues);
        this.authService.authDecryptConnectionStrings({ body: frmValues }).subscribe(res => {
            if (res) {
                this.isDecConVisiable = true;
                this.decitems = res as DecryptConnectionStringDto;
                console.log(this.decitems);
            }

            console.log(res);

        });
    }


    isFormFilled(): boolean {
        const values = this.connectionForm?.value;
        return !!(values &&
            ((values.careFinityConstring && values.careFinityConstring.trim().length > 0) ||
                (values.ehremrConstring && values.ehremrConstring.trim().length > 0)));
    }

    resetDecryptConStrings() {
        this.connectionForm.reset();
        this.decitems.ehremrConstring = null;
        this.decitems.careFinityConstring = null;
    }

    CloseDecryptConStrings() {
        this.isConnectionStringDecryptVisiable = false;
        this.connectionForm.reset();
        this.decitems.ehremrConstring = null;
        this.decitems.careFinityConstring = null;
        this.isDecConVisiable = false;
    }



    copyTextCareFinityConstring() {
        try {
            navigator.clipboard.writeText(this.decitems.careFinityConstring);
            console.log('Text copied to clipboard');

            // Change CSS by setting the flag
            this.isCopiedCareFinity = true;

            // Reset the copied status after 2 seconds
            setTimeout(() => {
                this.isCopiedCareFinity = false;
            }, 7000);
        } catch (err) {
            console.error('Failed to copy: ', err);
        }
    }

    copyTextEhremrConstring() {
        try {
            navigator.clipboard.writeText(this.decitems.ehremrConstring);
            console.log('Text copied to clipboard');
            this.isCopiedEhremrConstring = true;

            // Reset the copied status after 2 seconds
            setTimeout(() => {
                this.isCopiedEhremrConstring = false;
            }, 7000);
        } catch (err) {
            console.error('Failed to copy: ', err);
        }
    }
}
